import React, {useMemo, useRef} from "react";
import {useDriverList} from "~/apps/packages/auto-visits/hooks";
import { Autocomplete, AutocompleteProps } from '@mui/material';
import {TextField, TextFieldProps} from "@mui/material";
import {ArrayElement} from "~/types";
import {distinctByField} from "~/apps/core/utils";


export type Value = ArrayElement<ReturnType<typeof useDriverList>["data"]>

export type DriverSelectProps = Omit<TextFieldProps, "onChange" | "value"> & {
    value?: Value
    onChange?: (value: Value) => any
    additionalOptions?: Value[]
}


export const DriverSelect = (props: DriverSelectProps) => {
    const {value, onChange, additionalOptions, ...otherProps} = props;
    const {data} = useDriverList();
    const inputRef = useRef<HTMLInputElement>();
    const loading = !data;

    const availableValues: Value[] = useMemo(() => {
        return distinctByField([].concat(data).concat(additionalOptions).filter(Boolean), "name");
    }, [data, additionalOptions]);

    const handleChange = (e, value) => {
        inputRef?.current?.blur();
        onChange && onChange(value);
    }

    return (
        <Autocomplete
            {...otherProps as any as AutocompleteProps<Value, any, any, any>}
            value={value}
            onChange={handleChange}
            renderInput={props => (
                <TextField {...props} inputRef={inputRef} label="Водитель" placeholder="Выбрать"/>
            )}
            getOptionLabel={option => option.name}
            isOptionEqualToValue={(option, value) => value.name == option.name}
            options={availableValues}
            loading={loading}
            noOptionsText="Не найдено"
            loadingText="Загрузка..."
            blurOnSelect
        />
    );
}
